import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, EP3_score, currentPage, playAgain } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F69.css';
import backIcon2 from '../../../Assests/backIcon2.svg'
import webIcon from '../../../Assests/webIcon.svg'
import facebookIcon from '../../../Assests/facebookIcon.svg'
import twitterIcon from '../../../Assests/twitterIcon.svg'
import instagramIcon from '../../../Assests/instagramIcon.svg'
import ccp_logo from '../../../Assests/ccp_logo.png';
import eastwest_logo from '../../../Assests/eastwest_logo.png';

// import * as Icon from "react-icons/fi";
import checkIcon from '../../../Assests/checkIcon.svg'
import Checkbox from "react-custom-checkbox";


function Frame69() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let totalScoreArr = useSelector(EP3_score);
    let totalScore = 0;
    totalScoreArr.forEach((val)=>{if (val===true){totalScore=totalScore+1}})
 
        return (
            <div className='F69_mainDivAnimate'>
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <img className='F69_ccp_logo' src={ccp_logo} alt='ccp_logo' />
                <img className='F69_eastwest_logo' src={eastwest_logo} alt='eastwest_logo' />
                <div className="F69_box">
                    <div className='F69_boxTitle'>
                        <p className='F69_boxTitle_text'>
                            {language === 'english' ?
                                "Result"
                                :
                                "نتائج"
                            }
                        </p>
                    </div>

                    <div className='F69_scoreMessage'>
                        <p className='F69_scoreMessageText'>
                            {language === 'english' ?
                                `your score is ${totalScore} out of 4`
                                :
                                `آپ کا سکور 4 میں سے  ${totalScore}  ہے
                            `
                            }</p>
                    </div>

                    <div className='F69_result'>
                        <div className='F69_scoreBar'>
                            <div className='F69_scoreBarFilled'>
                                <div style={{
                                    backgroundColor: 'rgb(5, 138, 27)',
                                    height: '100%',
                                    width: `${(totalScore / 4) * 100}%`,
                                    borderRadius: '4%',
                                }}></div>
                            </div>
                        </div>

                        <div className='F69_scoreBarText'>
                            {language === 'english' ?
                                `Result ${((totalScore / 4) * 100).toFixed(1)} %`
                                :
                                `نتیجہ % ${((totalScore / 4) * 100).toFixed(1)}`
                            }
                        </div>
                    </div>

                    <div className='F69_buttonsDiv'>
                        <button onClick={() => {  window.open('https://ccp-pakistan.org.pk/project/addressing-menstrual-stigma-through-immersive-online-learning/','_blank'); }} className='F69_button'>
                            {language === 'english' ? 'More information' : 'مزید معلومات'}
                        </button>
                        <button onClick={() => { dispatch(playAgain()) }} className='F69_buttonPA'>
                            {language === 'english' ? 'Play again' : 'دوبارہ کھیلیں'}
                        </button>
                    </div>
                </div>

                <div className='F69_links'>
                    <div className='F69_link' onClick={() => { window.open('https://ccp-pakistan.org.pk', '_blank'); }}>
                        <img className='F69_linkIcons' src={webIcon} alt='webIcon' />
                        <span className='F69_linkText'>ccp-pakistan.org.pk</span>
                    </div>

                    <div className='F69_link' onClick={() => { window.open('https://www.facebook.com/ccp.pakistan', '_blank'); }}>
                        <img className='F69_linkIcons' src={facebookIcon} alt='facebookIcon' />
                        <span className='F69_linkText'>ccp.pakistan</span>
                    </div>

                    <div className='F69_link' onClick={() => { window.open('https://twitter.com/PakistanCCP', '_blank'); }}>
                        <img className='F69_linkIcons' src={twitterIcon} alt='twitterIcon' />
                        <span className='F69_linkText'>PakistanCCP</span>
                    </div>

                    <div className='F69_link' onClick={() => { window.open('https://www.instagram.com/ccp_pakistan', '_blank'); }}>
                        <img className='F69_linkIcons' src={instagramIcon} alt='instagramIcon' />
                        <span className='F69_linkText'>ccp_pakistan</span>
                    </div>
                </div>

            </div>
        )
    

}

export default Frame69